import Card from "components/card";
import { formatPrice } from "utils/price";
import { ACTIVATION_TYPES, SOURCE_TYPES } from "utils/constants";

const CardDx = ({ state, handleEdit }) => {
    const source = state?.data?.source;

    if (!state) return;

    return (
        <Card extra={"w-full p-4 sm:overflow-x-auto"}>
            <div className="relative mb-5 flex items-center">
                <div className="w-full text-2xl font-bold text-gray-800 dark:text-white">
                    Riepilogo Richiesta
                </div>
            </div>

            {state.data.licenses.length > 0 &&
            source !== SOURCE_TYPES.RESELLER ? (
                <>
                    {state.data.licenses.map((license) => {
                        if (license.active) {
                            return (
                                <div
                                    className={`mb-5 ${
                                        source === SOURCE_TYPES.RESELLER
                                            ? "flex justify-between"
                                            : ""
                                    }`}
                                    key={"licensesactivated" + license.code}
                                >
                                    <span className="text-sm font-medium text-gray-800">
                                        {license.name}{" "}
                                        {license.mode === "select"
                                            ? license.qty
                                            : ""}
                                    </span>

                                    <div className="flex justify-between">
                                        <div className="w-full md:w-1/2">
                                            <span className="whitespace-nowrap text-sm font-medium text-gray-600">
                                                {source ===
                                                SOURCE_TYPES.RESELLER
                                                    ? license.code !== "cluster"
                                                        ? license.code !==
                                                              "ssl" &&
                                                          license.mode !==
                                                              "select"
                                                            ? license.qty + " x"
                                                            : ""
                                                        : ""
                                                    : license.code !== "cluster"
                                                    ? license.code !== "ssl" &&
                                                      license.mode !== "select"
                                                        ? license.qty +
                                                          " x € " +
                                                          formatPrice(
                                                              license.price
                                                          )
                                                        : ""
                                                    : "+ " +
                                                      parseFloat(
                                                          license.price
                                                      ) *
                                                          100 +
                                                      "%"}
                                            </span>
                                        </div>

                                        {source !== SOURCE_TYPES.RESELLER && (
                                            <div className="flex w-full justify-end md:w-1/2">
                                                <span className="text-sm font-semibold text-gray-800">
                                                    {license.code !== "cluster"
                                                        ? "€ " +
                                                          formatPrice(
                                                              license.total
                                                          )
                                                        : "già calcolata"}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        }
                    })}

                    {state?.data?.maintenance !== undefined &&
                    state.type === ACTIVATION_TYPES.ONSITE ? (
                        <div className="mb-5" key={"maintenancetype"}>
                            <span className="text-sm font-medium text-gray-800">
                                Maintenance
                            </span>
                            {source !== SOURCE_TYPES.RESELLER && (
                                <div className="flex justify-between">
                                    <div className="w-w-full md:w-1/2">
                                        <span className="text-sm font-medium text-gray-600"></span>
                                    </div>
                                    <div className="flex w-full justify-end md:w-1/2">
                                        <span className="text-sm font-semibold text-gray-800">
                                            {"€ " +
                                                formatPrice(
                                                    state.data
                                                        ?.maintenance_data[
                                                        state?.data?.maintenance
                                                            ? state?.data
                                                                  ?.maintenance
                                                            : 0
                                                    ]?.price
                                                )}
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : null}
                </>
            ) : null}

            {source !== SOURCE_TYPES.RESELLER && (
                <div className="-mx-4 mb-4 flex flex-wrap bg-gray-200 py-6">
                    <div className="flex w-full justify-between px-4">
                        <div className="w-full md:w-1/2">
                            <span className="text-base font-bold text-gray-800">
                                Totale:
                            </span>
                        </div>
                        <div className="flex w-full justify-end md:w-1/2">
                            <span className="text-right text-base font-bold text-gray-800">
                                €{" "}
                                {state.data.total
                                    ? formatPrice(state?.data?.total)
                                    : 0}
                            </span>
                        </div>
                    </div>
                </div>
            )}

            <div className="flex flex-col gap-4">
                <button
                    type="button"
                    onClick={handleEdit}
                    className="linear bg-transparent w-full rounded-[8px] border border-brand-500 px-[34px] py-[12px] text-base font-bold uppercase text-brand-500 transition duration-200 hover:bg-brand-600 hover:text-white active:bg-brand-700 active:text-white dark:bg-brand-400 dark:text-brand-500 dark:hover:bg-brand-300 dark:hover:text-white dark:active:bg-brand-200 dark:active:text-white"
                >
                    Modifica
                </button>

                <button
                    type="submit"
                    className="linear w-full rounded-[8px] bg-brand-500 px-[34px] py-[12px] text-base font-bold uppercase text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                >
                    Conferma
                </button>
            </div>
        </Card>
    );
};

export default CardDx;
